/**
 * THis is just a copy of packages/web/src/ReactContexts/AuthContext/graphql/types/MeAuthContext.ts
 */
export var UserTagEnum;
(function (UserTagEnum) {
    UserTagEnum["B2B"] = "B2B";
    UserTagEnum["COLLEGE_SCHOLARSHIP"] = "COLLEGE_SCHOLARSHIP";
    UserTagEnum["MENTOR"] = "MENTOR";
    UserTagEnum["MENTOR_STAR"] = "MENTOR_STAR";
    UserTagEnum["PLUS"] = "PLUS";
    UserTagEnum["PREMIUM"] = "PREMIUM";
    UserTagEnum["PREMIUM_LITE"] = "PREMIUM_LITE";
    UserTagEnum["PREMIUM_STUDENT"] = "PREMIUM_STUDENT";
    UserTagEnum["PROFESSIONAL"] = "PROFESSIONAL";
    UserTagEnum["PROFESSOR"] = "PROFESSOR";
    UserTagEnum["SCHOLARSHIP"] = "SCHOLARSHIP";
    UserTagEnum["STAFF"] = "STAFF";
})(UserTagEnum || (UserTagEnum = {}));
export var MembershipTypeMethod;
(function (MembershipTypeMethod) {
    MembershipTypeMethod["A_1"] = "A_1";
    MembershipTypeMethod["A_2"] = "A_2";
})(MembershipTypeMethod || (MembershipTypeMethod = {}));
export var MyUserTypeDocument;
(function (MyUserTypeDocument) {
    MyUserTypeDocument["DNI"] = "DNI";
    MyUserTypeDocument["FOREIGNER_CARD"] = "FOREIGNER_CARD";
    MyUserTypeDocument["PASSPORT"] = "PASSPORT";
})(MyUserTypeDocument || (MyUserTypeDocument = {}));
export var UserDegreeSegmentationEnum;
(function (UserDegreeSegmentationEnum) {
    UserDegreeSegmentationEnum["ACTIVATED_DEGREE_SEGMENTATION"] = "ACTIVATED_DEGREE_SEGMENTATION";
    UserDegreeSegmentationEnum["EXPIRED_DEGREE_SEGMENTATION"] = "EXPIRED_DEGREE_SEGMENTATION";
})(UserDegreeSegmentationEnum || (UserDegreeSegmentationEnum = {}));
export var MembershipTypeTag;
(function (MembershipTypeTag) {
    MembershipTypeTag["BECADO"] = "BECADO";
    MembershipTypeTag["FAMILIAR"] = "FAMILIAR";
    MembershipTypeTag["ONG_BECADO"] = "ONG_BECADO";
    MembershipTypeTag["ORGANIZATION"] = "ORGANIZATION";
    MembershipTypeTag["PLUS"] = "PLUS";
    MembershipTypeTag["PREMIUM"] = "PREMIUM";
    MembershipTypeTag["PREMIUM_DUO"] = "PREMIUM_DUO";
    MembershipTypeTag["PREMIUM_LITE"] = "PREMIUM_LITE";
    MembershipTypeTag["PREMIUM_STUDENT"] = "PREMIUM_STUDENT";
    MembershipTypeTag["PROFESIONAL"] = "PROFESIONAL";
    MembershipTypeTag["UNIVERSITY_SCHOLARSHIP"] = "UNIVERSITY_SCHOLARSHIP";
})(MembershipTypeTag || (MembershipTypeTag = {}));
export var UserB2BStatusEnum;
(function (UserB2BStatusEnum) {
    UserB2BStatusEnum["ACTIVE"] = "ACTIVE";
    UserB2BStatusEnum["DELETE"] = "DELETE";
    UserB2BStatusEnum["INACTIVE"] = "INACTIVE";
    UserB2BStatusEnum["PENDING"] = "PENDING";
})(UserB2BStatusEnum || (UserB2BStatusEnum = {}));
//# sourceMappingURL=Me.js.map